export default "__VITE_ASSET__ChLsKFJs__"